import { action, makeObservable, observable } from "mobx";
import { v4 as uuid } from "uuid";

export class BannerStore {
  @observable banners;

  constructor() {
    makeObservable(this);
    this.banners = [];
  }

  // TODO - How do I add @action back here?

  @action
  setBanners(banners) {
    this.banners = banners;
  }

  @action
  addBanner(color, title, body) {
    const id = uuid();
    this.banners.push({ id, color, title, body });
  }

  @action
  deleteBanner(bannerId) {
    this.banners = this.banners.filter((banner) => banner.id !== bannerId);
  }
}

export default BannerStore;
